export const wordDataSelector = (state) => state.dictionary;
